module.exports = __webpack_public_path__ + "static/media/emptyDatasetPage.d4eebe15.svg";